import { render, staticRenderFns } from "./PageChargeBalanceHistory.vue?vue&type=template&id=68be24c5"
import script from "./PageChargeBalanceHistory.vue?vue&type=script&lang=js"
export * from "./PageChargeBalanceHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports